import { defineMessages } from "react-intl";

import { node as anthropometrics } from "src/modules/ltx/forms/phase-ii/anthropometrics";
import { node as imagingProceduresIi } from "src/modules/ltx/forms/phase-ii/imaging-procedures-ii";
import { node as consultationsIi } from "src/modules/ltx/forms/phase-ii/consultations-ii";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.phase_ii",
		defaultMessage: "Fázis II"
	}
});

export const node: ParentNode = {
	id: "phaseII",
	value: { type: "wizard", title: messages.title },
	children: [anthropometrics, imagingProceduresIi, consultationsIi]
};
